var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-semi-circle-gauges-card"},_vm._l((_vm.computedTelemetries),function(t){return _c('div',{key:t.name,staticClass:"l-semi-circle-gauges-card__gauge"},[_c('SemiCircleGauge',{attrs:{"metricData":t}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }